import React from "react";
import PropTypes from "prop-types";

import Spin from "../../../../spin";

function LoadingGradient({ loading }) {
  if (loading) {
    return (
      <div className="table-loading-content">
        <div className="gradient" />

        <div className="spin">
          <Spin loading={loading} />
        </div>
      </div>
    );
  } else {
    return null;
  }
}

LoadingGradient.defaultProps = {
  loading: false
};

LoadingGradient.propTypes = {
  loading: PropTypes.bool
};

export default LoadingGradient;
